module.exports = __webpack_public_path__ + "assets/c4b876637d2ad366a17e0bc4a1bbbbd4.jpg";